<template>
  <DropDownButton
    v-if="hasDropDownItems"
    data-test="shipment-menu"
    :primary-button="regularShipping">
    <DropDownItem>
      <RouterLink :to="{name: regularShipping.routeName}">
        {{ regularShipping.label }}
      </RouterLink>
    </DropDownItem>
    <template v-for="item in otherShippingActions">
      <DropDownItem
        v-if="item.enabled"
        :key="item.label">
        <ExternalLinkAnchor :href="item.href">
          {{ item.label }}
        </ExternalLinkAnchor>
      </DropDownItem>
    </template>
    <template v-if="socialShipping.enabled">
      <DropDownItemDivider />
      <DropDownItem>
        <ExternalLinkAnchor :href="socialShipping.href">
          {{ socialShipping.label }}
        </ExternalLinkAnchor>
      </DropDownItem>
    </template>
  </DropDownButton>
  <RouterLink
    v-else
    :to="{name: regularShipping.routeName}">
    <Button :variant="ButtonVariant.Secondary">
      {{ regularShipping.label }}
    </Button>
  </RouterLink>
</template>

<script setup lang="ts">
import {useProposition} from '@myparcel-frontend/proposition';
import {ExternalLinkAnchor, Button, ButtonVariant} from '@myparcel-frontend/ui';
import {computed} from 'vue';
import {useI18n} from 'vue-i18n';
import {RouterLink} from 'vue-router';
import DropDownButton from '@/components/ui/Dropdown/DropDownButton/DropDownButton.vue';
import DropDownItem from '@/components/ui/Dropdown/DropDownItem/DropDownItem.vue';
import DropDownItemDivider from '@/components/ui/Dropdown/DropDownItemDivider/DropDownItemDivider.vue';

const {proposition} = useProposition();
const {t} = useI18n();

const regularShipping = computed(() => ({
  label: t('shipment.newShipment'),
  routeName: 'shipments-create',
  enabled: true,
}));

const socialShipping = computed(() => ({
  label: t('shipment.createSocialLink'),
  href: '/shipments?modal=social-shipping',
  enabled: proposition.value.shipments.enableSocialShipping,
}));

const otherShippingActions = computed(() => [
  {
    label: t('shipment.pallet'),
    href: '/shipments/pallet/create',
    enabled: proposition.value.shipments.enablePallet,
  },
  {
    label: t('shipment.return', 2),
    href: '/shipments/return/create',
    enabled: proposition.value.shipments.enableReturn,
  },
  {
    label: t('shipment.multiple'),
    href: '/shipments/import',
    enabled: proposition.value.shipments.enableCsvImport,
  },
  {
    label: t('shipment.importExport.title'),
    href: '/shipments/import-export',
    enabled: proposition.value.shipments.enableGoodsImportExport,
  },
]);

const hasDropDownItems = computed(() => {
  return socialShipping.value.enabled || otherShippingActions.value.some((item) => item.enabled);
});
</script>
